import { keyframes } from '@mui/system';

import { colors } from '../../theme';

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.45; }
  100% { opacity: 1; }
`;

const bar = {
  height: 12,
  borderRadius: '6px',
  backgroundColor: colors.surfaceHover,
  animation: `${pulse} 1.4s ease-in-out infinite`,
};

// Same size as the frame of FeedPlayer and the column of FeedActions.
const styles = {
  frame: {
    position: 'relative',
    height: '100%',
    aspectRatio: '9 / 16',
    maxWidth: '100%',
    flexShrink: 0,
    borderRadius: '14px',
    overflow: 'hidden',
    backgroundColor: colors.surface,
  },
  spinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    mt: '-17px',
    ml: '-17px',
    color: 'rgba(255, 255, 255, 0.8)',
  },
  info: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    px: 2,
    pb: 2.25,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.25,
  },
  username: {
    ...bar,
    width: '35%',
    height: 14,
  },
  line: {
    ...bar,
    width: '80%',
  },
  shortLine: {
    ...bar,
    width: '55%',
  },
  progress: {
    height: 3,
    borderRadius: '2px',
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
  },
  rail: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 3,
    // Same bottom as the rail of the real player (FeedActions).
    pb: '31px',
    minWidth: 56,
    flexShrink: 0,
  },
  railItem: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: colors.surfaceRaised,
    animation: `${pulse} 1.4s ease-in-out infinite`,
  },
};

export default styles;
